let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jNUXl")).then(() => parcelRequire('fx0K9'));